module.exports = __webpack_public_path__ + "img/bron.9a16b4b1.svg";